import { useState } from "react"
import { Popover, Table, TableCell, TableHead, TableRow } from "@mui/material"
import { ArrowDropDown } from "@mui/icons-material"
import { isFunction, map, size } from "lodash"
import PropTypes from "prop-types"
import OPTooltip from "components/material/tooltip"
import TableDropdownBody from "./components/body"
import { COLUMN_SHAPE } from "./shapes"
import "./styles.scss"

export default function TableDropdown({ label, columns, items, onItemClick, selectedItemId, isActive, formatter }) {
  const [popperAnchor, setPopperAnchor] = useState(null)

  const handleClick = (item) => {
    setPopperAnchor(null)
    onItemClick(item)
  }

  return (<span className="component_table-dropdown">
    {size(items) === 1
      ? label
      : <>
        <OPTooltip enterDelay={300} title={label}><a onClick={(event) => setPopperAnchor(event.target)}>{label} <ArrowDropDown /></a></OPTooltip>
        <Popover
          anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
          }}
          transformOrigin={{
              vertical: "top",
              horizontal: "center",
          }}
          classes={{
              root: "component_table-dropdown-popover",
          }}
          open={!!popperAnchor}
          onClose={() => setPopperAnchor(null)}
          anchorEl={popperAnchor}
          transitionDuration={0}
        >
          <Table className="component_table-dropdown-table">
            <TableHead>
              <TableRow>
                {map(columns, ({ id, label, align }) => {
                    return <TableCell
                      key={id}
                      align={align ?? "right"}
                    >
                      {isFunction(label) ? label(isActive) : label}
                    </TableCell>
                  })}
              </TableRow>
            </TableHead>
            <TableDropdownBody {...{ columns, items, onItemClick: handleClick, selectedItemId, formatter }} />
          </Table>
        </Popover>
      </>}
  </span>)
}

TableDropdown.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]).isRequired,
  columns: PropTypes.arrayOf(COLUMN_SHAPE).isRequired,
  items: PropTypes.array.isRequired,
  onItemClick: PropTypes.func.isRequired,
  selectedItemId: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  formatter: PropTypes.func,
}
